import React from "react";
import Image from "components/image";
import { getRgba } from "helpers/get-rgba";

const WithCollaboration = ({ collaboration }) => {
	const { image, bgColor = "red", title, text } = collaboration;
	return (
		<div className="flex justify-center py-4 mb-4" style={{ backgroundColor: getRgba(bgColor) }}>
			<Image className="rounded-full self-center w-11 h-11" image={image} alt={image?.alt} />
			<div className="ml-5">
				<span className="text-secondary-darker tracking-widest text-small mb-4">{title}</span>
				<p className="mt-1.5">{text}</p>
			</div>
		</div>
	);
};

export default WithCollaboration;
